import { Product } from './types';

// Stock-truth state machine. Driven by the platform's inventory.availableQty
// (Product.stock). NEVER invents a number when stock is absent.
export type StockState = 'unknown' | 'sold-out' | 'low' | 'normal';

// Low when at/under 2× MOQ or a small absolute floor — whichever is larger.
const LOW_STOCK_ABSOLUTE = 100;
export const lowStockThreshold = (product: Product): number =>
  Math.max(LOW_STOCK_ABSOLUTE, Math.max(product.moq, 1) * 2);

export const stockState = (product: Product): StockState => {
  const qty = product.stock;
  if (qty == null) return 'unknown';
  if (qty <= 0) return 'sold-out';
  if (qty <= lowStockThreshold(product)) return 'low';
  return 'normal';
};

export const isSoldOut = (product: Product): boolean =>
  stockState(product) === 'sold-out';

export const hasKnownStock = (product: Product): boolean =>
  product.stock != null && product.stock > 0;

// Clamp qty to available stock when known; pass through when unknown.
export const clampToStock = (product: Product, qty: number): number =>
  hasKnownStock(product) ? Math.min(qty, product.stock as number) : qty;
